var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07811 11.5766L12.6181 6.03511C12.6431 6.01021 12.6548 5.97652 12.6518 5.94282L12.2783 1.52778C12.2681 1.41353 12.1787 1.32417 12.0644 1.31392L7.6494 0.941847C7.61571 0.938917 7.58055 0.950636 7.55711 0.975539L2.01708 6.51558C1.99527 6.5376 1.98303 6.56735 1.98303 6.59834C1.98303 6.62934 1.99527 6.65908 2.01708 6.68111L6.91258 11.5766C6.95799 11.6235 7.0327 11.6235 7.07811 11.5766ZM8.87547 3.76314C9.1494 3.48921 9.59471 3.48921 9.8701 3.76314C10.144 4.03706 10.144 4.48237 9.8701 4.75777C9.59618 5.03169 9.15086 5.03169 8.87547 4.75777C8.60155 4.48384 8.60155 4.03853 8.87547 3.76314ZM13.0327 7.90718L12.4526 7.32857C12.4306 7.30676 12.4009 7.29452 12.3699 7.29452C12.3389 7.29452 12.3091 7.30676 12.2871 7.32857L6.98436 12.621L3.50389 9.14937C3.48187 9.12756 3.45212 9.11532 3.42113 9.11532C3.39013 9.11532 3.36039 9.12756 3.33836 9.14937L2.75829 9.72798C2.73648 9.75 2.72424 9.77975 2.72424 9.81074C2.72424 9.84174 2.73648 9.87148 2.75829 9.89351L6.32079 13.4501L6.90086 14.0288C6.94627 14.0742 7.02098 14.0742 7.06639 14.0288L13.0327 8.07271C13.0781 8.0273 13.0781 7.95259 13.0327 7.90718Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.58712dd411f032567e86e52247a0b952.svg";
export { ForwardRef as ReactComponent };